/**
 * e付通项目参数
 */
export default {
	state: {
		// header——学生信息查询
		studentMessageObject: null,
		// header——学生信息详情
		studentMessageDetailObject: {
			dl_dm: '',
			chargeOverview: null,
			chargeYSK: null,
			chargeCanPay: null,
			chargeAlreadyPay: null,
		},
		// 统计汇总
		statisticActiveTabs: 'StaAccChildCharge',
		feeDetailActiveTabs: 'collectionDetail',
		statisticToPage: {
			isClicked: false,
			dataRangeValue: null,
		},
		// 等级考试——当前项目信息
		gradeTestCurrentKeyId: '', // key_id
		gradeTestCurrentObject: null, // 对象
		gradeTestImportXH: {
			xhs: [],
			xhsName: [],
			templateMsg: null,
		},
		gradeTestImportSJH: {
			sjhs: [],
			sjhsName: [],
			templateMsg: null,
		},

		// 工本费——当前项目信息
		costCurrentKeyId: '', // key_id
		costCurrentObject: null, // 对象
		costImportXH: {
			xhs: [],
			xhsName: [],
			templateMsg: null,
		},
		costImportSJH: {
			sjhs: [],
			sjhsName: [],
			templateMsg: null,
		},

		// 捐款——当前项目信息
		donationCurrentKeyId: '', // key_id
		donationCurrentObject: null, // 对象

		// 报名考试——当前项目信息
		exCurrentKeyId: '', // key_id
		exCurrentObject: null, // 对象

		// 学费——当前项目信息
		tuitionId: '', // key_id
		tuitionItem: null, // 对象

		// 应收款——当前项目信息对象
		canChargeKey_Id: '', // key_id
		canChargeKeyId: null, // 对象
		// 标准发布信息保存
		standardPublishObj: {
			// 人员范围
			filterArr: [],
			studentIdArr: [],
			importMessageArr: [],
			// 添加收费标准数据展示
			chargeStandardArr: [],
		},

		// 党费——当前项目信息
		pmdTestCurrentKeyId: '', // key_id
		pmdTestCurrentObject: null, // 对象
		pmdTestImportXH: {
			xhs: [],
			xhsName: [],
			templateMsg: null,
		},
		pmdTestImportSJH: {
			sjhs: [],
			sjhsName: [],
			templateMsg: null,
		},
		messageArr: [],
		pendingReviewRefresh: false, // 变更及审核记录-待审核变更时触发刷新变量
	},
	mutations: {
		// header——学生信息查询
		setStudentMessageObject(state, payload) {
			state.studentMessageObject = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.studentMessageObject = JSON.stringify(state.studentMessageObject);
			}
		},
		initStudentMessageObject(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.studentMessageObject = JSON.parse(window.localStorage.studentMessageObject);
			}
		},
		// 统计汇总
		setStatisticActiveTabs(state, payload) {
			state.statisticActiveTabs = payload;
		},
		// 收费项明细
		setFeeDetailActiveTabs(state, payload) {
			state.feeDetailActiveTabs = payload;
		},
		saveFeeDetailActiveTabs(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.feeDetailActiveTabs = state.feeDetailActiveTabs;
			}
		},
		saveStatisticActiveTabs(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.statisticActiveTabs = state.statisticActiveTabs;
			}
		},
		initFeeDetailActiveTabs(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.statisticActiveTabs = window.localStorage.statisticActiveTabs;
			}
		},
		initStatisticActiveTabs(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.statisticActiveTabs = window.localStorage.statisticActiveTabs;
			}
		},
		// 首页——页面跳转保存数据
		setStatisticToPage(state, payload) {
			state.statisticToPage = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.statisticToPage = JSON.stringify(state.statisticToPage);
			}
		},
		initStatisticToPage(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.statisticToPage =
					JSON.parse(window.localStorage.statisticToPage || '{}');
			}
		},
		/* 等级考试 */
		setGradeTestCurrentKeyId(state, payload) {
			state.gradeTestCurrentKeyId = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.gradeTestCurrentKeyId = state.gradeTestCurrentKeyId;
			}
		},
		initGradeTestCurrentKeyId(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.gradeTestCurrentKeyId = window.localStorage.gradeTestCurrentKeyId;
			}
		},
		setGradeTestCurrentObject(state, payload) {
			state.gradeTestCurrentObject = JSON.parse(JSON.stringify(payload));
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.gradeTestCurrentObject = JSON.stringify(state.gradeTestCurrentObject);
			}
		},
		initGradeTestCurrentObject(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.gradeTestCurrentObject = JSON.parse(window.localStorage.gradeTestCurrentObject);
			}
		},
		// 导入学号
		setGradeTestImportXH(state, payload) {
			state.gradeTestImportXH = payload;
		},
		saveGradeTestImportXH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.gradeTestImportXH = JSON.stringify(state.gradeTestImportXH);
			}
		},
		initGradeTestImportXH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				// console.log(window.localStorage.gradeTestImportXH);
				state.gradeTestImportXH = JSON.parse(window.localStorage.gradeTestImportXH);
			}
		},
		// 导入手机号
		setGradeTestImportSJH(state, payload) {
			state.gradeTestImportSJH = payload;
		},
		saveGradeTestImportSJH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.gradeTestImportSJH = JSON.stringify(state.gradeTestImportSJH);
			}
		},
		initGradeTestImportSJH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.gradeTestImportSJH = JSON.parse(window.localStorage.gradeTestImportSJH);
			}
		},
		/* 党费 */
		setPmdTestCurrentKeyId(state, payload) {
			state.pmdTestCurrentKeyId = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.pmdTestCurrentKeyId = state.pmdTestCurrentKeyId;
			}
		},
		initPmdTestCurrentKeyId(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.pmdTestCurrentKeyId = window.localStorage.pmdTestCurrentKeyId;
			}
		},
		setPmdTestCurrentObject(state, payload) {
			state.pmdTestCurrentObject = JSON.parse(JSON.stringify(payload));
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.pmdTestCurrentObject = JSON.stringify(state.pmdTestCurrentObject);
			}
		},
		initPmdTestCurrentObject(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.pmdTestCurrentObject = JSON.parse(window.localStorage.pmdTestCurrentObject);
			}
		},
		// 导入学号
		setPmdTestImportXH(state, payload) {
			state.pmdTestImportXH = payload;
		},
		savePmdTestImportXH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.pmdTestImportXH = JSON.stringify(state.pmdTestImportXH);
			}
		},
		initPmdTestImportXH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				// console.log(window.localStorage.gradeTestImportXH);
				state.pmdTestImportXH = JSON.parse(window.localStorage.pmdTestImportXH);
			}
		},
		// 导入手机号
		setPmdTestImportSJH(state, payload) {
			state.pmdTestImportSJH = payload;
		},
		savePmdTestImportSJH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.pmdTestImportSJH = JSON.stringify(state.pmdTestImportSJH);
			}
		},
		initPmdTestImportSJH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.pmdTestImportSJH = JSON.parse(window.localStorage.pmdTestImportSJH);
			}
		},

		/* 工本费 */
		setCostCurrentKeyId(state, payload) {
			state.costCurrentKeyId = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.costCurrentKeyId = state.costCurrentKeyId;
			}
		},
		initCostCurrentKeyId(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.costCurrentKeyId = window.localStorage.costCurrentKeyId;
			}
		},
		setCostCurrentObject(state, payload) {
			state.costCurrentObject = JSON.parse(JSON.stringify(payload));
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.costCurrentObject = JSON.stringify(state.costCurrentObject);
			}
		},
		initCostCurrentObject(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.costCurrentObject = JSON.parse(window.localStorage.costCurrentObject);
			}
		},
		// 导入学号
		setCostImportXH(state, payload) {
			state.costImportXH = payload;
		},
		saveCostImportXH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.costImportXH = JSON.stringify(state.costImportXH);
			}
		},
		initCostImportXH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				// console.log(window.localStorage.costImportXH);
				state.costImportXH = JSON.parse(window.localStorage.costImportXH);
			}
		},
		// 导入手机号
		setCostImportSJH(state, payload) {
			state.costImportSJH = payload;
		},
		saveCostImportSJH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.costImportSJH = JSON.stringify(state.costImportSJH);
			}
		},
		initCostImportSJH(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.costImportSJH = JSON.parse(window.localStorage.costImportSJH);
			}
		},

		/* 捐款 */
		setDonationCurrentKeyId(state, payload) {
			state.donationCurrentKeyId = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.donationCurrentKeyId = state.donationCurrentKeyId;
			}
		},
		initDonationCurrentKeyId(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.donationCurrentKeyId = window.localStorage.donationCurrentKeyId;
			}
		},
		setDonationCurrentObject(state, payload) {
			state.donationCurrentObject = JSON.parse(JSON.stringify(payload));
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.donationCurrentObject = JSON.stringify(state.donationCurrentObject);
			}
		},
		initDonationCurrentObject(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.donationCurrentObject = JSON.parse(window.localStorage.donationCurrentObject);
			}
		},

		// 报名考试 ExCurrentKeyId: '',    // key_id
		//		ExCurrentObject
		setExCurrentKeyId(state, payload) {
			state.exCurrentKeyId = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.donationCurrentKeyId = state.exCurrentKeyId;
			}
		},
		initExCurrentKeyId(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.exCurrentKeyId = window.localStorage.donationCurrentKeyId;
			}
		},
		setExCurrentObject(state, payload) {
			state.exCurrentObject = JSON.parse(JSON.stringify(payload));
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.donationCurrentObject = JSON.stringify(state.exCurrentObject);
			}
		},
		initExCurrentObject(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.exCurrentObject = JSON.parse(window.localStorage.exCurrentObject);
			}
		},

		/* 应收款 */
		setCanChargeKey_Id(state, payload) {
			state.canChargeKey_Id = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.canChargeKey_Id = state.canChargeKey_Id;
			}
		},
		initCanChargeKey_Id(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.canChargeKey_Id = window.localStorage.canChargeKey_Id;
			}
		},
		setCanChargeKeyId(state, payload) {
			state.canChargeKeyId = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.canChargeKeyId = JSON.stringify(state.canChargeKeyId);
			}
		},
		initCanChargeKeyId(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.canChargeKeyId = JSON.parse(window.localStorage.canChargeKeyId);
			}
		},
		/* 学费 */
		setTuitionId(state, payload) {
			state.tuitionId = payload;
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.tuitionId = state.tuitionId;
			}
		},
		initTuitionId(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.tuitionId = window.localStorage.tuitionId;
			}
		},
		setTuitionItem(state, payload) {
			state.tuitionItem = JSON.parse(JSON.stringify(payload));
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.tuitionItem = JSON.stringify(state.tuitionItem);
			}
		},
		initTuitionItem(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.tuitionItem = JSON.parse(window.localStorage.tuitionItem);
			}
		},
		// 标准发布信息保存
		setStandardPublishObj(state, payload) {
			state.standardPublishObj = JSON.parse(JSON.stringify(payload));
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.standardPublishObj = JSON.stringify(state.standardPublishObj);
			}
		},
		saveStandardPublishObj(state) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				window.localStorage.standardPublishObj = JSON.stringify(state.standardPublishObj);
			}
		},
		initStandardPublishObj(state, payload) {
			if (!window.localStorage) {
				console.log('系统不支持localStorage');
			} else {
				state.standardPublishObj = JSON.parse(window.localStorage.standardPublishObj);
			}
		},
		setMessageArr(state, payload) {
			state.messageArr.push(payload);
			const pay = new Set(state.messageArr);
			pay.add(payload);
			state.messageArr = Array.from(pay);
		},
		deleteMessage(state, payload) {
			state.messageArr.push(payload);
			const pay = new Set(state.messageArr);
			pay.delete(payload);
			state.messageArr = Array.from(pay);
		},
		clearMessage(state) {
			state.messageArr = [];
		},

		// 变更及审核记录-待审核变更时触发
		upPendingReviewRefresh(state) {
			state.pendingReviewRefresh = !state.pendingReviewRefresh;
		},
	},
	getters: {},
};

